export const state = (): LocationState => ({
  locationPins: [],
  locationInfo: {
    displayName: "",
    savings: 0,
    identifier: "",
    localExperts: 0,
    moves: 0,
    summaryHeading: "",
    summaryUsp1: "",
    summaryUsp1Emoji: "",
    summaryUsp2: "",
    summaryUsp2Emoji: "",
    summaryUsp3: "",
    summaryUsp3Emoji: ""
  }
})

export const GET_MAP_LOCATION = "getMapLocation"
export const GET_LOCATION_INFO = "getLocationInfo"

export const getters = {
  [GET_MAP_LOCATION]: (state: LocationState): MapLocation[] => state.locationPins,
  [GET_LOCATION_INFO]: (state: LocationState): LocationInfo => state.locationInfo
}

export const _SET_MAP_LOCATIONS = "setMapLocations"
export const _SET_LOCATION_INFO = "setLocationInfo"

export const mutations = {
  [_SET_MAP_LOCATIONS](state: LocationState, locations: MapLocation[]) {
    state.locationPins = locations
  },
  [_SET_LOCATION_INFO](state: LocationState, locations: LocationInfo) {
    state.locationInfo = locations
  }
}

export const SET_MAP_LOCATIONS = "setMapLocations"
export const SET_LOCATION_INFO = "setLocationInfo"

export const actions = {
  [SET_MAP_LOCATIONS]({ commit }, locationData: PageLocation) {
    const latitudeList: number[] = locationData.mapPinsLatitude.split(/,/g).map(parseFloat)
    const longitudeList: number[] = locationData.mapPinsLongitude.split(/,/g).map(parseFloat)
    const textLine1List: string[] = locationData.mapPinsTextLine1.split(/,/g).map(str => str.trim())
    const textLine2List: string[] = locationData.mapPinsTextLine2.split(/,/g).map(str => str.trim())
    const textLine3List: string[] = locationData.mapPinsTextLine3.split(/,/g).map(str => str.trim())
    const starsList: string[] = locationData.mapPinsStars.split(/,/g).map(str => str.trim())
    const imageIds: string[] = (locationData.mapPinsImageIDs || "generic")
      .split(/,/g)
      .map(str => str.trim())

    const locations: MapLocation[] = latitudeList.map((value, index) => {
      return {
        id: index,
        lat: value,
        lng: longitudeList[index],
        textLine1: textLine1List[index],
        textLine2: textLine2List[index],
        textLine3: textLine3List[index],
        stars: starsList[index],
        imageID: imageIds[index]
      }
    })
    commit(_SET_MAP_LOCATIONS, locations)
  },
  [SET_LOCATION_INFO]({ commit }, locationData: PageLocation) {
    commit(_SET_LOCATION_INFO, {
      displayName: locationData.locationDisplayName,
      identifier: locationData.locationIdentifier,
      localExperts: locationData.summaryLocalExperts,
      savings: locationData.summarySavings,
      moves: locationData.summaryNeighboursMoved,
      summaryHeading: locationData.summaryHeading,
      summaryUsp1: locationData.summaryUsp1,
      summaryUsp1Emoji: locationData.summaryUsp1Emoji,
      summaryUsp2: locationData.summaryUsp2,
      summaryUsp2Emoji: locationData.summaryUsp2Emoji,
      summaryUsp3: locationData.summaryUsp3,
      summaryUsp3Emoji: locationData.summaryUsp3Emoji
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
